import { css } from '@emotion/css'

export const SecondaryAuthContainer = css`
  width: 45px;
  height: 45px;
  border-radius: 50%;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition-duration: 300ms;
  cursor: pointer;
`

export const IconWrapper = css`
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
`
